import { AppState, UrlPartSerializer } from '@immosky/types';
import { TypedAction } from '@ngrx/store/src/models';
import { setSort } from './sort.actions';
import { availableSortOptions } from './sort.state';

export class SortFilterSerializer implements UrlPartSerializer {
  constructor(public readonly key: string) {}

  deserialize(urlValue: string): TypedAction<string> {
    const option =
      availableSortOptions.find((o) => o.value === urlValue) ||
      availableSortOptions[0];

    return setSort({
      sort: option,
    });
  }

  serialize(state: AppState): string {
    const sort = state.filter.sort.sort;
    return sort.value;
  }
}
